import React from 'react'
import { ControlledTooltip } from '../index'

type Props = {
  content?: string
  title?: string
  children?: JSX.Element
}

// wrapper for header statistics, if we have content, wrap in tooltip
export const TooltipWrapper: React.FC<Props> = ({
  content,
  title,
  children,
}: {
  content?: string
  title?: string
  children?: JSX.Element
}) => {
  // if we have content and children, wrap children in tooltip
  if (content && title) {
    return (
      <ControlledTooltip triangle content={content} title={title}>
        {children}
      </ControlledTooltip>
    )
  }
  return null
}
